const storageKeyForStoredListsByContextId = 'storedListsByContextId';

export class ProductComparisonStorage {
    constructor(private _storage: Storage = localStorage) {}

    private storeItem(key: string, value: string) {
        return this._storage.setItem(key, value);
    }

    private retrieveStoredItem(key: string): string | null {
        return this._storage.getItem(key);
    }

    private removeStoredItem(key: string): void {
        this._storage.removeItem(key);
    }

    public retrieveStoredListsByContextId(): Record<string, string[]> | null {
        const storedListsByContextId = this.retrieveStoredItem(storageKeyForStoredListsByContextId);
        return storedListsByContextId !== null ? (JSON.parse(storedListsByContextId) as Record<string, string[]>) : null;
    }

    private storeListsByContextId(listsByContextId: Record<string, string[]>) {
        this.storeItem(storageKeyForStoredListsByContextId, JSON.stringify(listsByContextId));
    }

    public storeListForContextId(contextId: string, list: string[]) {
        const listsByContextId = this.retrieveStoredListsByContextId();

        if (listsByContextId === null) {
            const newListsByContextId: Record<string, string[]> = {};
            newListsByContextId[contextId] = list;
            this.storeListsByContextId(newListsByContextId);
        } else {
            listsByContextId[contextId] = list;
            this.storeListsByContextId(listsByContextId);
        }
    }

    public retrieveStoredListForContextId(contextId: string): string[] | null {
        const storedListsByContextId = this.retrieveStoredListsByContextId();
        return storedListsByContextId !== null && contextId in storedListsByContextId
            ? Object.assign([], storedListsByContextId[contextId])
            : null;
    }

    public removeStoredListForContextId(contextId: string): string | null {
        const storedListsByContextId = this.retrieveStoredListsByContextId();

        if (storedListsByContextId === null || !(contextId in storedListsByContextId)) {
            return null;
        }

        delete storedListsByContextId[contextId];
        this.storeListsByContextId(storedListsByContextId);
        return contextId;
    }

    public clearStoredListsByContextId(): void {
        this.removeStoredItem(storageKeyForStoredListsByContextId);
    }
}
